import { atom } from "recoil";
export const barcodeAddState = atom({
  key: "barcodeAddState",
  default: {
    emp_cd: "",
    tg_bran_cd: "",
    pob: "",
    car_num: "",
  },
});
